import React, { Component } from 'react'
import { withRouter, Link } from "react-router-dom";
import { Card, Image, Button } from 'react-bootstrap'
import { Scrollbars } from 'react-custom-scrollbars'
import logo from '../../../images/logo.svg'
import BrandLogo from "./BrandLogo";
import * as Cookies from "es-cookie";

import './_navbars.scss'
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";

const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
        borderRadius: 6,
        width: '3px',
        backgroundColor: 'rgba(25, 255, 255, 0.1)'
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
};
const renderThumbNew = ({ style, ...props }) => {
    const thumbStyle = {
        borderRadius: 6,
        width: '8px',
        backgroundColor: 'rgba(25, 5, 5, 0.2)'
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
};

class MockExamAsideBar extends Component {
    constructor(props) {
        super(props)
        const questionsData = props.stateData.questions.map((item) => {
            return { ...item, sidebutton: "0" }

        });
        this.state = {
            questions: questionsData,
            //examSubjects: props.stateData.examSubjects
        }
    }
    section(index) {
        if (index == 35) {
            return <div className="d-block  text-dark">

            </div>
        }
    }
    idFunction(data) {
        let id = parseInt(data + 1);
        return id;
    }
    classNameFunction(data) {

        let cname = "list-inline-item";
        if (data.review == true && data.attempted != null) {
            //console.log("classNameFunction1", this.props.stateData.questions[this.props.stateData.index]);
            cname = "list-inline-item markreview checked";
        }
        else if (data.review == true) {
            //console.log("classNameFunction2", this.props.stateData.questions[this.props.stateData.index]);
            cname = "list-inline-item markreview";
        }
        else if (data.attempted != null) {
            //console.log("classNameFunction3", this.props.stateData.questions[this.props.stateData.index]);
            cname = "list-inline-item attempted";
        }
        else if (data.status == "skip") {
            //console.log("classNameFunction4", this.props.stateData.questions[this.props.stateData.index]);
            cname = "list-inline-item skip";
        }
        else if (data.status == "" && data.saveandnext == "1") {
            //console.log("classNameFunction5", this.props.stateData.questions[this.props.stateData.index]);
            cname = "list-inline-item skip";
        }
        return cname;

    }

    answeredandmarkedreviewCount(data) {
        let count = data.filter((a) => a.attempted != null && a.review == true)
        return count.length;

    }
    notViewedCountFunction(data) {

        // let wrongA = [];
        // let currectA = [];
        // let skipA = [];
        // for (let i = 0; i < data.length; i++) {
        //     let idata = data[i];
        //     if (idata.status == "wrong") {
        //         const id = idata.id;
        //         wrongA.push(id);
        //     }
        //     else if (idata.status == "currect") {
        //         const id = idata.id;
        //         currectA.push(id);
        //     }
        //     else if (idata.status == "skip") {
        //         const id = idata.id;
        //         skipA.push(id);
        //     }
        //     else if (idata.status == "" && idata.saveandnext == "1") {
        //         const id = idata.id;
        //         skipA.push(id);
        //     }

        // }
        ////console.log("notViewedCountFunction",data , wrongA.length , currectA.length , skipA.length);
        //let nviewed = parseInt(data.length - wrongA.length - currectA.length - skipA.length);

        const nviewed = data.filter((a) => a.status == "").length;
        return nviewed;
    }
    wrongFunction(data) {
        let wrongA = [];
        for (let i = 0; i < data.length; i++) {
            let idata = data[i];
            if (idata.isSubmitted == true) {
                if (idata.status == "wrong") {
                    const id = idata.id;
                    wrongA.push(id);
                }
            }

        }
        return wrongA.length;
    }

    skipFunction(data) {
        let skipA = [];
        for (let i = 0; i < data.length; i++) {
            let idata = data[i];
            if ((idata.status == "skip" && idata.review == false) || (idata.status == "" && idata.saveandnext == "1" && idata.review == false)) {
                ////console.log("skipskip");
                skipA.push(idata.id);
            }
        }
        return skipA.length;
    }
    reviewFunction(data) {

        let reviewA = [];
        for (let i = 0; i < data.length; i++) {
            let idata = data[i];
            if (idata.attempted == null && idata.review == true) {
                const id = idata.id;
                reviewA.push(id);
            }
        }
        return reviewA.length;
    }

    currentFunction(data) {
        let currectA = [];
        for (let i = 0; i < data.length; i++) {
            let idata = data[i];
            if (idata.attempted != null) {
                const id = idata.id;
                currectA.push(id);
            }
        }
        return currectA.length;
    }
    render() {
        const lqlength = this.props.stateData.questions.length - 1;
        //console.log("pesection", this.props.stateData.questions.filter((a) => a.sidebutton == "0"));
        const qudata = this.props.stateData.questions.filter((a) => a.sidebutton == "0");
        //console.log("ExamAsideBar", this.props.examInstructions);
        const esubjects = this.props.stateData.examSubjects;
        //console.log("userid",Cookies.get("examid"))

        //let examModalId = this.props.examInstructions.exam_model_id;
        //console.log("this.props.stateData.questions",this.props.stateData.sideBarToggled)

        return (
            <div id="examAsidebar" className="exam-asidebar">
                <div className="sidebar-header px-3 py-2" style={{ display: "flex", justifyContent: "center" }}>
                    <Link
                    //to="/student/home"
                    >
                        {/* <Image className="logo" src={logo} width="100" alt="Image" /> */}
                        <BrandLogo width="159.501" className="logo" style={{ width: "87%" }} />

                    </Link>
                </div>
                <Scrollbars style={{ height: '80vh' }}
                    renderThumbVertical={renderThumb}
                    autoHide
                    autoHideTimeout={500}
                    autoHideDuration={200}>
                    <ul className="assessment-nav-filter p-2 m-0">
                        {esubjects.map((item, index) => {
                            //console.log('subjectFilter',item);
                            return (<li className={item.active}>
                                <a onClick={() => this.props.subjectFilter(item.id)}>{item.subject}</a>
                            </li>);
                        })}
                    </ul>

                    <div className="questionnor_block m-3">
                        <div style={{ border: "2px dashed black", margin: "-1px -11px", padding: "0px 11px" }}>

    {/* Top Status Row */}
    <div className="mark_status mt-2 d-flex justify-content-between">

        {/* Left Section */}
        <div className="d-flex flex-column">

            {/* Not Viewed */}
            <div className="single_mark d-flex align-items-center border-0 p-0">
                <span
                    className="icon_status"
                    style={{ display: "inline-block", width: "40px", height: "40px", textAlign: "center", lineHeight: "37px" }}
                >
                    <small className="status_count text-white">
                        {this.notViewedCountFunction(this.props.stateData.questions)}
                    </small>
                </span>
                <span className="status_name ml-2 text-dark">Not Viewed</span>
            </div>
   {/* Answered */}
            <div className="single_mark d-flex align-items-center border-0 p-0 ">
                <span
                    className="icon_status attempted"
                    style={{ display: "inline-block", width: "40px", height: "40px", textAlign: "center", lineHeight: "37px" }}
                >
                    <small className="status_count text-white">
                        {this.currentFunction(this.props.stateData.questions)}
                    </small>
                </span>
                <span className="status_name ml-2 text-dark">Answered</span>
            </div>
          

        </div>

        {/* Right Section */}
        <div className="d-flex flex-column">

         


              {/* Skip */}
            <div className="single_mark d-flex align-items-center  border-0 p-0 ml-1">
                <span
                    className="icon_status skip"
                    style={{ display: "inline-block", width: "40px", height: "40px", textAlign: "center", lineHeight: "37px" }}
                >
                    <small className="status_count text-white">
                        {this.skipFunction(this.props.stateData.questions)}
                    </small>
                </span>
                <span className="status_name ml-2 text-dark">Not Answered</span>
            </div>

            {/* Marked for Review */}
            <div className="single_mark d-flex align-items-center  border-0 p-0 ml-1">
                <span
                    className="icon_status markreview"
                    style={{ display: "inline-block", width: "40px", height: "40px", textAlign: "center", lineHeight: "37px" }}
                >
                    <small className="status_count text-white">
                        {this.reviewFunction(this.props.stateData.questions)}
                    </small>
                </span>
                <span className="status_name ml-2 text-dark">Marked for Review</span>
            </div>

        </div>

    </div>

    {/* Bottom Section */}
    <div className="mark_status  ml-1">
        <div className="single_mark d-flex align-items-center">

            <span
                className="icon_status markreview checked"
                style={{ width: "40px", height: "40px", textAlign: "center", lineHeight: "37px" }}
            >
                <small className="status_count text-white">
                    {this.answeredandmarkedreviewCount(this.props.stateData.questions)}
                </small>
            </span>

            <span className="ml-2 text-dark">
                Answered and Marked for Review
            </span>

        </div>
    </div>

</div>
                        

                        <div className="d-flex justify-content-between mb-2 text-dark">
                            <h6 className='mt-4'>Questions</h6>
                            <h6 className='mt-4'>{qudata.length}</h6>
                        </div>
                        <Scrollbars style={{ height: 200 }}
                            renderThumbVertical={renderThumbNew}
                            autoHideTimeout={500}
                            autoHideDuration={200}>
                            <ul className="questionNos list-inline">

                                {this.props.stateData.questions.map((Data, index) => {
                                    if (Data.sidebutton == "0") {
                                        return (
                                            <>
                                                {
                                                    Data.exam_pattern_id > 0 ?
                                                        (

                                                            <>
                                                                {
                                                                    (Data.indexvalue == Data.starting_no_val) ?
                                                                        (<h6 className="text-dark">{Data.section_name}</h6>)
                                                                        : ""
                                                                }

                                                                <li className={this.classNameFunction(Data)} onClick={(e) => this.props.psideQFun(index)}>{this.idFunction(index)}{this.section(index)}</li>
                                                            </>
                                                        )
                                                        :
                                                        (
                                                            <>
                                                                {
                                                                    this.props.examInstructions != undefined && this.props.examInstructions.exam_model_id == 2 ?
                                                                        (
                                                                            <>
                                                                                {
                                                                                    index == 0 ? <h6 className="text-dark">Section-A</h6> : index == 35 ? <h6 className="text-dark">Section-B</h6> :
                                                                                        index == 50 ? <h6 className="text-dark">Section-A</h6> : index == 85 ? <h6 className="text-dark">Section-B</h6> :
                                                                                            index == 100 ? <h6 className="text-dark">Section-A</h6> : index == 135 ? <h6 className="text-dark">Section-B</h6> :
                                                                                                index == 150 ? <h6 className="text-dark">Section-A</h6> : index == 185 ? <h6 className="text-dark">Section-B</h6>
                                                                                                    : ""

                                                                                }
                                                                                <li className={this.classNameFunction(Data)} onClick={(e) => this.props.psideQFun(index)}>{this.idFunction(index)}{this.section(index)}</li>
                                                                            </>
                                                                        )
                                                                        :
                                                                        (<li className={this.classNameFunction(Data)} onClick={(e) => this.props.psideQFun(index)}>{this.idFunction(index)}{this.section(index)}</li>)
                                                                }
                                                            </>

                                                        )
                                                }
                                            </>
                                        )

                                    }

                                })}
                            </ul>
                        </Scrollbars>

                    </div>
                </Scrollbars>
                <div className="footer-block pb-3 text-center">
                    <ul className="list-unstyled">

                        {/* <li>
                            {this.props.stateData.index != lqlength ? ("") : (<Button variant="success" className="px-4" onClick={this.props.ParenthandleFormSubmit}>Finish Exam</Button>)}
                        </li> */}
                    </ul>
                </div>

            </div>
        )
    }
}

export default withRouter(MockExamAsideBar);
